export default __webpack_public_path__ + "static/media/photo--lg--35.f6eefdfb.jpg";